var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServicesImg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_11",
    fill: "#B09A68",
    d: "M60,61c0-0.553,0.447-1,1-1s1,0.447,1,1s-0.447,1-1,1S60,61.553,60,61z M54,61 c0-0.553,0.447-1,1-1s1,0.447,1,1s-0.447,1-1,1S54,61.553,54,61z M6,61c0-0.553,0.448-1,1-1s1,0.447,1,1s-0.448,1-1,1S6,61.553,6,61 z M0,61c0-0.553,0.448-1,1-1s1,0.447,1,1s-0.448,1-1,1S0,61.553,0,61z M60,55c0-0.553,0.447-1,1-1s1,0.447,1,1s-0.447,1-1,1 S60,55.553,60,55z M0,55c0-0.553,0.448-1,1-1s1,0.447,1,1s-0.448,1-1,1S0,55.553,0,55z M60,7c0-0.552,0.447-1,1-1s1,0.448,1,1 s-0.447,1-1,1S60,7.553,60,7z M0,7c0-0.552,0.448-1,1-1s1,0.448,1,1S1.552,8,1,8S0,7.553,0,7z M60,1c0-0.552,0.447-1,1-1 s1,0.448,1,1s-0.447,1-1,1S60,1.553,60,1z M54,1c0-0.552,0.447-1,1-1s1,0.448,1,1s-0.447,1-1,1S54,1.553,54,1z M6,1 c0-0.552,0.448-1,1-1s1,0.448,1,1S7.552,2,7,2S6,1.553,6,1z M0,1c0-0.552,0.448-1,1-1s1,0.448,1,1S1.552,2,1,2S0,1.553,0,1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    transform: "translate(-159 -1615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    fill: "#303034",
    d: "M210.5,1640c-0.276,0-0.5,0.224-0.5,0.5v20c0,0.276-0.224,0.5-0.5,0.5h-39 c-0.276,0-0.5-0.224-0.5-0.5v-20c0-0.276-0.224-0.5-0.5-0.5s-0.5,0.224-0.5,0.5v20c0,0.828,0.671,1.5,1.5,1.5h39 c0.828,0,1.5-0.672,1.5-1.5v-20C211,1640.224,210.776,1640,210.5,1640z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    fill: "#303034",
    d: "M209.5,1630h-39c-0.829,0-1.5,0.671-1.5,1.5v6c0,0.276,0.224,0.5,0.5,0.5h41 c0.276,0,0.5-0.224,0.5-0.5v-6C211,1630.671,210.328,1630,209.5,1630z M210,1637h-40v-5.5c0-0.276,0.224-0.5,0.5-0.5h39 c0.276,0,0.5,0.224,0.5,0.5V1637z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    fill: "#303034",
    d: "M186.5,1658c0.276,0,0.5-0.224,0.5-0.5v-16c0-0.276-0.224-0.5-0.5-0.5h-13 c-0.276,0-0.5,0.224-0.5,0.5v16c0,0.276,0.224,0.5,0.5,0.5H186.5z M174,1642h12v15h-12V1642z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    fill: "#303034",
    d: "M191.5,1645h15c0.276,0,0.5-0.224,0.5-0.5s-0.224-0.5-0.5-0.5h-15 c-0.276,0-0.5,0.224-0.5,0.5S191.224,1645,191.5,1645z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    fill: "#303034",
    d: "M191.5,1650h15c0.276,0,0.5-0.224,0.5-0.5s-0.224-0.5-0.5-0.5h-15 c-0.276,0-0.5,0.224-0.5,0.5S191.224,1650,191.5,1650z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    fill: "#303034",
    d: "M191.5,1655h15c0.276,0,0.5-0.224,0.5-0.5s-0.224-0.5-0.5-0.5h-15 c-0.276,0-0.5,0.224-0.5,0.5S191.224,1655,191.5,1655z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    fill: "#303034",
    cx: 173,
    cy: 1634,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    fill: "#303034",
    cx: 177,
    cy: 1634,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38",
    fill: "#303034",
    cx: 181,
    cy: 1634,
    r: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesImg5);
export default __webpack_public_path__ + "static/media/services_img_5.1ab6f94e6833cb3e97baf951f752ee49.svg";
export { ForwardRef as ReactComponent };